import AreaCookieController from './area_cookie_controller'

window.Stimulus.register('area-cookie', AreaCookieController)
